import(/* webpackMode: "eager" */ "/opt/thedesperatetrader/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/src/components/DividendCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/src/components/InlineEmailCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/src/components/InlineFreeAlertsCta.tsx");
